import { LoadingSkeleton } from "@faire/slate/components/loading-skeleton";

import { resultsGridStyle } from "./resultsGridStyles";

interface ResultsGridSkeletonProps {
  /** How many placeholder tiles to render while a batch is in flight. */
  tileCount: number;
}

/**
 * Placeholder tiles standing in for an incoming batch.
 *
 * Written here rather than reusing `sc/filters`' version: that one is
 * `lg:grid-cols-4` against this page's `lg:grid-cols-5`, so it would shift the
 * layout at `lg` right as results land. Sharing `resultsGridStyle` with the
 * real grid instead means the columns match by construction.
 */
export function ResultsGridSkeleton({ tileCount }: ResultsGridSkeletonProps) {
  return (
    <div aria-busy="true" aria-live="polite" className={resultsGridStyle.cls()}>
      {Array.from({ length: tileCount }, (_unused, index) => (
        <SkeletonTile key={index} />
      ))}
    </div>
  );
}

/**
 * Four text lines below the image, mirroring `ProductTileATCCompact`'s rows:
 * price, product name, brand, and the min/rating line. Widths vary so the
 * block reads as text rather than as a stack of identical bars.
 */
function SkeletonTile() {
  return (
    <div className="flex flex-col gap-(--slate-dimensions-2)">
      <div className="aspect-square w-full">
        <LoadingSkeleton height="100%" variant="canvas" width="100%" />
      </div>
      <LoadingSkeleton variant="paragraphText" width={80} />
      <LoadingSkeleton variant="paragraphText" width={160} />
      <LoadingSkeleton variant="paragraphText" width={110} />
      <LoadingSkeleton variant="paragraphText" width={90} />
    </div>
  );
}
